import * as api from 'services/api'

const oneComment = {
	state: {
		id: '',
		detail: {},
		comments: []
	},
	mutations: {
		'oneComment:update'(state, payload) {
			console.log(payload)
			state.id = payload.id;
			state.detail = payload.detail;
			state.comments = payload.comments;
		}
	},
	actions: {
		async 'oneComment:init'({commit}, id) {
			const res = await api.getCommentDetail({commentId: id});
			if(res.result.code === 0) {
				const data = res.data;
				const detail = {};
				detail.articleId = data.articleId;
				detail.sysCode = data.sysCode;
				//detail.type = data.article_type;
				detail.title = data.title;
				//detail.news_link = data.article_link;
				//detail.category_id = data.category_id;
				//detail.share_slogan = data.content;
				const comments = [data.comment];
				commit('oneComment:update', {id, detail, comments});
			}
		}
	},
	getters: {
		'oneComment:detail': state => {
			return state.detail;
		},
		'oneComment:comments': state => {
			return state.comments;
		} 
		
	}
};

export default oneComment;


// WEBPACK FOOTER //
// ./src/store/modules/one-comment.js